function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { DateTime as t } from "@easepick/datetime";
import { BasePlugin as i } from "@easepick/base-plugin";

var s = /*#__PURE__*/function (_i) {
  _inherits(s, _i);

  var _super = _createSuper(s);

  function s() {
    var _this;

    _classCallCheck(this, s);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.priority = 1;
    _this.binds = {
      onView: _this.onView.bind(_assertThisInitialized(_this))
    };
    _this.options = {
      minDate: null,
      maxDate: null,
      minDays: null,
      maxDays: null,
      selectForward: null,
      selectBackward: null,
      presets: !0,
      inseparable: !1,
      filter: null
    };
    return _this;
  }

  _createClass(s, [{
    key: "getName",
    value: function getName() {
      return "LockPlugin";
    }
  }, {
    key: "onAttach",
    value: function onAttach() {
      if (this.options.minDate && (this.options.minDate = new t(this.options.minDate, this.picker.options.format, this.picker.options.lang)), this.options.maxDate && (this.options.maxDate = new t(this.options.maxDate, this.picker.options.format, this.picker.options.lang), this.options.maxDate instanceof t && this.picker.options.calendars > 1 && this.picker.calendars[0].isSame(this.options.maxDate, "month"))) {
        var _t = this.picker.calendars[0].clone().subtract(1, "month");

        this.picker.gotoDate(_t);
      }

      if ((this.options.minDays || this.options.maxDays || this.options.selectForward || this.options.selectBackward) && !this.picker.options.plugins.includes("RangePlugin")) {
        var _t2 = ["minDays", "maxDays", "selectForward", "selectBackward"];
        console.warn("".concat(this.getName(), ": options ").concat(_t2.join(", "), " required RangePlugin."));
      }

      this.picker.on("view", this.binds.onView);
    }
  }, {
    key: "onDetach",
    value: function onDetach() {
      this.picker.off("view", this.binds.onView);
    }
  }, {
    key: "onView",
    value: function onView(i) {
      var _i$detail = i.detail,
          _s = _i$detail.view,
          e = _i$detail.target,
          a = _i$detail.date;

      if ("CalendarHeader" === _s && (this.options.minDate instanceof t && a.isSameOrBefore(this.options.minDate, "month") && e.classList.add("no-previous-month"), this.options.maxDate instanceof t && a.isSameOrAfter(this.options.maxDate, "month") && e.classList.add("no-next-month")), "CalendarDay" === _s) {
        var _t3 = this.picker.datePicked.length ? this.picker.datePicked[0] : null;

        if (this.testFilter(a)) return void e.classList.add("locked");

        if (this.options.inseparable) {
          if (this.options.minDays) {
            var _t4 = a.clone().subtract(this.options.minDays - 1, "day"),
                _i2 = a.clone().add(this.options.minDays - 1, "day");

            var _s7 = !1,
                o = !1;

            for (; _t4.isBefore(a, "day");) {
              if (this.testFilter(_t4)) {
                _s7 = !0;
                break;
              }

              _t4.add(1, "day");
            }

            for (; _i2.isAfter(a, "day");) {
              if (this.testFilter(_i2)) {
                o = !0;
                break;
              }

              _i2.subtract(1, "day");
            }

            _s7 && o && e.classList.add("not-available");
          }

          this.rangeIsNotAvailable(a, _t3) && e.classList.add("not-available");
        }

        this.dateIsNotAvailable(a, _t3) && e.classList.add("not-available");
      }

      if (this.options.presets && "PresetPluginButton" === _s) {
        var _i3 = new t(Number(e.dataset.start)),
            _s8 = new t(Number(e.dataset.end)),
            _a = _s8.diff(_i3, "day"),
            _o = this.options.minDays && _a < this.options.minDays,
            n = this.options.maxDays && _a > this.options.maxDays;

        (_o || n || this.lockMinDate(_i3) || this.lockMaxDate(_i3) || this.lockMinDate(_s8) || this.lockMaxDate(_s8) || this.rangeIsNotAvailable(_i3, _s8)) && e.setAttribute("disabled", "disabled");
      }
    }
  }, {
    key: "dateIsNotAvailable",
    value: function dateIsNotAvailable(t, i) {
      return this.lockMinDate(t) || this.lockMaxDate(t) || this.lockMinDays(t, i) || this.lockMaxDays(t, i) || this.lockSelectForward(t) || this.lockSelectBackward(t);
    }
  }, {
    key: "rangeIsNotAvailable",
    value: function rangeIsNotAvailable(t, i) {
      if (!t || !i) return !1;

      var _s4 = (t.isSameOrBefore(i, "day") ? t : i).clone(),
          e = (i.isSameOrAfter(t, "day") ? i : t).clone();

      for (; _s4.isSameOrBefore(e, "day");) {
        if (this.testFilter(_s4)) return !0;

        _s4.add(1, "day");
      }

      return !1;
    }
  }, {
    key: "lockMinDate",
    value: function lockMinDate(i) {
      return this.options.minDate instanceof t && i.isBefore(this.options.minDate, "day");
    }
  }, {
    key: "lockMaxDate",
    value: function lockMaxDate(i) {
      return this.options.maxDate instanceof t && i.isAfter(this.options.maxDate, "day");
    }
  }, {
    key: "lockMinDays",
    value: function lockMinDays(t, i) {
      if (this.options.minDays && i) {
        var _s9 = i.clone().subtract(this.options.minDays - 1, "day"),
            e = i.clone().add(this.options.minDays - 1, "day");

        return t.isBetween(_s9, e);
      }

      return !1;
    }
  }, {
    key: "lockMaxDays",
    value: function lockMaxDays(t, i) {
      if (this.options.maxDays && i) {
        var _s10 = i.clone().subtract(this.options.maxDays, "day"),
            e = i.clone().add(this.options.maxDays, "day");

        return !t.isBetween(_s10, e);
      }

      return !1;
    }
  }, {
    key: "lockSelectForward",
    value: function lockSelectForward(t) {
      if (1 === this.picker.datePicked.length && this.options.selectForward) {
        var _i4 = this.picker.datePicked[0].clone();

        return t.isBefore(_i4, "day");
      }

      return !1;
    }
  }, {
    key: "lockSelectBackward",
    value: function lockSelectBackward(t) {
      if (1 === this.picker.datePicked.length && this.options.selectBackward) {
        var _i5 = this.picker.datePicked[0].clone();

        return t.isAfter(_i5, "day");
      }

      return !1;
    }
  }, {
    key: "testFilter",
    value: function testFilter(t) {
      return "function" == typeof this.options.filter && this.options.filter(t, this.picker.datePicked);
    }
  }]);

  return s;
}(i);

export { s as LockPlugin };